<div class="row">
  <div class="col-12 d-flex align-items-center">
    <button
      class="btn btn-flat"
      id="collapser"
      type="button"
      [class.no-click]="!expandable"
      [attr.aria-hidden]="!expandable"
      [attr.aria-label]="expandable ? header : null"
      [attr.tabindex]="expandable ? null : -1"
      [attr.aria-expanded]="expandable ? !isCollapsed : null"
      (click)="expandable && collapse.toggle()"
    >
      @if (isCollapsed || !expandable) {
        <svg class="chevron-icon" aria-hidden="true">
          <use xlink:href="#chevron-right-thin"></use>
        </svg>
      } @else {
        <svg class="chevron-icon" role="img" aria-hidden="true">
          <use xlink:href="#chevron-bottom-thin"></use>
        </svg>
      }
    </button>
    <span class="fw-bold text-black ms-1 me-2" id="header">
      {{ header }}
    </span>
    <ng-content select="[commentHeaderExtra]"></ng-content>
    @if (deletable) {
      <button
        (click)="deleted.emit(id)"
        id="delete-button"
        class="btn btn-flat btn-link text-underline fw-bold comment-header-action"
      >
        {{ 'action_delete' | translate }}
      </button>
    }
  </div>
</div>

<div class="row">
  <div class="col-12 ps-5 text-black">
    {{ 'label_comment_user_timestamp' | translate: [date, time, author]
    }}<ng-content select="[commentTimestampExtra]"></ng-content>
  </div>
</div>

<div class="row mt-2" [class.d-none]="!expandable">
  <div class="col-12 ps-5">
    <div
      id="content"
      #collapse="ngbCollapse"
      [ngbCollapse]="isCollapsed"
      (ngbCollapseChange)="onCollapsedChange($event)"
      class="text-black"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
